// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { api } from "../../Appjs/api.js";
import { secureBaseQuery } from "./secureBaseQuery.js";
import {dynamicBaseQuery} from "./dynamicBaseQuery.js";

// Define a service using a base URL and expected endpoints
// export const principleApi = createApi({
//   reducerPath: "principleApi",
 
//   tagTypes: ["Princepal"],
export const principleApi = createApi({
  reducerPath: "principleApi",
  // baseQuery: dynamicBaseQuery,
 baseQuery: fetchBaseQuery({
    baseUrl: api,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Princepal"],
  endpoints: (builder) => ({
    fetchPrincipalEntitiesdata: builder.query({
      query: () => ({
        url: "/principal/getPrincipalEntities",
        method: "GET",
      }),
      providesTags: ["Princepal"],
    }),
    createPrincipalEntries: builder.mutation({
      query: (data) => ({
        url: "/principal/principalEntities",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Princepal"],
    }),
    updatePrincipalEntries: builder.mutation({
      query: (data) => ({
        url: `/principal/principalEntities/${data.principalId}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Princepal"],
    }),
    deletePrincipalEntries: builder.mutation({
      query: (principalId) => ({
        url: `/principal/principalEntities/${principalId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Princepal"],
    }),

    getSearchFiles: builder.query({
      query: () => ({
        url: "/report/get-search-files",
        method: "GET",
      }),
    }),

    getFilterReports: builder.query({
      query: () => ({
        url: "/filter/reports",
        method: "GET",
      }),
      providesTags: ["FilterReports"],
    }),
  }),
});

export const {
  useFetchPrincipalEntitiesdataQuery,
  useCreatePrincipalEntriesMutation,
  useDeletePrincipalEntriesMutation,
  useUpdatePrincipalEntriesMutation,
  useGetSearchFilesQuery,
  useGetFilterReportsQuery,
} = principleApi;
